import { gql } from "graphql-request";

import { Contact } from "../types";

import { axiosQuery } from "./axiosHelpers";
import { throwError } from "./errorHandler";

type Field =
  | "address1"
  | "address2"
  | "postalCode"
  | "city"
  | "state"
  | "country";

export interface Problem {
  field: Field | null;
  message: string;
}

interface AddressValidation {
  success: boolean;
  problems: Problem[];
}

interface AddressValidationResponse {
  validateAddress: AddressValidation;
}

const VALIDATE_ADDRESS_QUERY = gql`
  query ValidateAddress($shipToContact: ApiContactInput!) {
    validateAddress(shipToContact: $shipToContact) {
      success
      problems {
        field
        message
      }
    }
  }
`;

export const validateAddress = async (
  shipToContact: Contact,
): Promise<AddressValidation> => {
  try {
    const res = await axiosQuery<AddressValidationResponse>(
      "ValidateAddress",
      VALIDATE_ADDRESS_QUERY,
      {
        shipToContact: shipToContact,
      },
    );
    return res.validateAddress;
  } catch (e) {
    throw throwError("errorOnAddressValidation", e);
  }
};
